import React, { useEffect, useState } from "react";
import axios from "axios";
import PosterModal from "./modal/PosterModal";

export default function PosterListPage() {
    const [allKeywords, setAllKeywords] = useState([]);
    const [activeKeywords, setActiveKeywords] = useState([]);
    const [posters, setPosters] = useState([]);
    const [selectedPoster, setSelectedPoster] = useState(null);

    // 키워드 목록 불러오기
    const loadKeywords = () => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/poster/registered-keywords`)
            .then((res) => setAllKeywords(res.data))
            .catch((err) => console.error(err));
    };

    // 포스터 목록 불러오기
    const loadPosters = () => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/poster/all`)
            .then((res) => setPosters(res.data))
            .catch((err) => console.error(err));
    };

    const reloadDatas = () => {
        loadPosters();
        loadKeywords();
    }

    // 첫 로딩 시 포스터 / 키워드 불러오기
    useEffect(() => {
        reloadDatas()
    }, []);

    // 키워드 필터 로직
    const filteredPosters =
        activeKeywords.length === 0
            ? posters
            : posters.filter((poster) =>
                poster.keywords?.some((k) => activeKeywords.includes(k))
            );

    // 키워드 토글
    const toggleKeyword = (keyword) => {
        setActiveKeywords((prev) =>
            prev.includes(keyword)
                ? prev.filter((k) => k !== keyword)
                : [...prev, keyword]
        );
    };

    // PosterModal에서 키워드를 수정한 후, 전체 포스터 리스트도 업데이트
    const handleUpdatePoster = (updatedPoster) => {
        setPosters((prev) =>
            prev.map((p) => (p.id === updatedPoster.id ? updatedPoster : p))
        );
        // 키워드 목록도 다시 불러와야 한다면
        loadKeywords();
    };

    return (
        <div className="max-w-7xl mx-auto p-6 space-y-6">
            <h2 className="text-xl font-bold">키비주얼 목록</h2>

            {/* 키워드 필터 버튼들 */}
            <div className="flex flex-wrap gap-2">
                {allKeywords.map((k, i) => (
                    <button
                        key={i}
                        onClick={() => toggleKeyword(k)}
                        className={`px-3 py-1 rounded-full border text-sm ${
                            activeKeywords.includes(k)
                                ? "bg-blue-600 text-white"
                                : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                        }`}
                    >
                        {k}
                    </button>
                ))}
            </div>

            {/*
              [여기서 카드의 그리드 열 개수와 간격을 조정할 수 있습니다]
              grid-cols-2 => 작은 화면에서 2열
              md:grid-cols-3 => 중간 화면 이상에서 3열
              lg:grid-cols-4 => 큰 화면 이상에서 4열
              gap-6 => 카드 사이 간격
            */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 ">
                {filteredPosters.map((poster) => (
                    <div
                        key={poster.id}
                        // [카드 스타일: 높이/너비 등 변경 가능]
                        // hover:shadow-xl -> 마우스 올렸을 때 그림자 진해짐
                        // transition-shadow -> 그림자가 부드럽게 변하도록
                        className="slow-animation bg-gray-50 rounded cursor-pointer
                                   p-2 w-full h-[400px] hover:shadow-xl transition-shadow
                                   "
                        onClick={() => setSelectedPoster(poster)} // 클릭 시 모달 열기
                    >
                        {/*
                          [이미지 스타일: object-cover로 카드에 맞게 꽉 차도록]
                          h-full => 카드 높이에 맞춰서 전체 영역 채우도록
                          w-full => 가로도 전부 채우도록
                          rounded => 모서리 둥글게
                          object-cover => 비율을 유지하면서 카드에 꽉 차게
                        */}
                        <img
                            src={`${process.env.REACT_APP_API_REAL_URL}/${poster.filePath}`}
                            alt={poster.name}
                            className="w-full h-full object-cover rounded "
                        />
                    </div>
                ))}
            </div>

            {/* 포스터 모달 */}
            {selectedPoster && (
                <PosterModal
                    poster={selectedPoster}
                    onClose={() => setSelectedPoster(null)}
                    onUpdatePoster={handleUpdatePoster}
                />
            )}
        </div>
    );
}